import type { World } from './world.js';

const SWARM_CLEAR_BONUS = 250;

/**
 * Add score to the first alive player (single-player prototype).
 * Also tracks hi-score watermark.
 */
export function addScore(world: World, amount: number): void {
  for (const p of world.players) {
    if (!p.alive) continue;
    p.score += amount;
    if (p.score > world.hiScore) world.hiScore = p.score;
    return;
  }
  // No alive player: still track the run if a dead player exists.
  if (world.players.length > 0) {
    const p = world.players[0];
    p.score += amount;
    if (p.score > world.hiScore) world.hiScore = p.score;
  }
}

/**
 * Called whenever a swarm-group enemy dies. If the last one in the group, award bonus.
 */
export function trackSwarmKill(world: World, group: string): void {
  if (!group) return;
  let remaining = 0;
  for (const e of world.enemies) {
    if (e.alive && e.group === group) remaining++;
  }
  if (remaining === 0) {
    addScore(world, SWARM_CLEAR_BONUS);
  }
}
